<template>
  <div class="flex flex-col w-full gap-2 relative mt-7">
    <span v-if="label" class="absolute -top-7 left-0 font-body-2-strong">
      {{ label }} <span v-if="isRequired" class="text-danger-600">*</span>
    </span>
    <ClientOnly>
      <O360SingleSelect
        :allow-add="allowAdd"
        :greyout-parent-options="greyoutParentOptions"
        :options="options"
        :selected="selected"
        :nested-options="nestedOptions"
        :non-selectable-option-tooltip="nonSelectableOptionTooltip"
        :placeholder="placeholder"
        :border-class="borderClass"
        :validator="validator"
        :validation-error="validationError"
        :caret-class="'text-accent-500'"
        :searchable="true"
        :scrollable="scrollable"
        @add-custom="(item) => emit('add-custom', item)"
        @option-selected="(item) => emit('optionSelected', item)"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import { TOOLTIP_DIRECTION, type ListItem } from "@airpr/360-ui-components";
import O360SingleSelect from "../360-ui-components/O360SingleSelect.vue";

defineProps({
  allowAdd: {
    type: Boolean,
    default: false,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String || null,
    default: null,
  },
  options: {
    type: Array as PropType<ListItem[]>,
    required: true,
  },
  selected: {
    type: Object as PropType<ListItem | undefined>,
    required: true,
  },
  placeholder: {
    type: String,
    default: "",
  },
  scrollable: {
    type: Boolean,
    default: false,
  },
  borderClass: {
    type: String,
    default: "border-accent-100",
  },
  nestedOptions: {
    type: Boolean,
    default: false,
  },
  validator: {
    type: Function,
    default: () => true,
  },
  validationError: {
    type: Function,
    default: () => "Invalid entry",
  },
  nonSelectableOptionTooltip: {
    type: String || null,
    default: null,
  },
  nonSelectableOptionTooltipDirection: {
    type: String,
    default: TOOLTIP_DIRECTION.top,
    validator(value: string) {
      return Object.values(TOOLTIP_DIRECTION).includes(value);
    },
  },
  greyoutParentOptions: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["add-custom", "optionSelected"]);
</script>
